module.exports = __webpack_public_path__ + "img/18.8f83a87a.svg";